// extracted by mini-css-extract-plugin
export default {"actions-strip":"actions-strip__fU5Dd","actionsStrip":"actions-strip__fU5Dd"};